export default {
  account_id_required: "ID akun dibutuhkan.",
  account_not_exists: "Kata sandi salah",
  accountIdRequired: "Sesi berakhir! Silakan masuk lagi untuk melanjutkan...",
  agent_comm_rate_required: "Rate komisi agen dibutuhkan.",
  agent_id_required: "ID agen dibutuhkan.",
  alphaNumOnly: "Hanya alfanumerik",
  atLeastThreeMatchToBetParlay: "Setidaknya mencampur tiga pertandingan untuk bertaruh dalam parlay",
  atLeastTwoMatchToBetParlay: "Setidaknya mencampur dua pertandingan untuk bertaruh dalam parlay",
  bet_amount_required: "Jumlah taruhan dibutuhkan.",
  bet_id_required: "ID taruhan dibutuhkan.",
  betAmountRequired: "Jumlah taruhan diperlukan.",
  betExists: "Taruhan sudah ada.",
  betLowerMin: "Your stake less than the min stake.",
  betNotExists: "Silakan pasang taruhan yang valid untuk mengikuti turnamen.",
  betOverMax: "Your stake exceeds the max stake.",
  betOverMaxBet: "Your stake exceeds the max stake.",
  betOverMaxPerMatch: "Taruhan Anda melebihi taruhan maks",
  betTypeRequired: "Tipe taruhan diperlukan.",
  BLOCK: "Akun telah diblokir!",
  changeStakeMax: "Masukan nilai stake telah diubah karena batas MAX.",
  changeStakeMin: "Masukan nilai stake telah diubah karena batas MIN.",
  CLOSE: "Akun telah ditutup!",
  close: "Akun ditutup! Silakan hubungi upline Anda untuk melanjutkan...",
  confirmNewPasswordRequired: "Diperlukan kata sandi baru!",
  connectionFailed: "Gagal menghubungkan sistem dompet.",
  containAlphaNum: "{fname} harus memiliki setidaknya satu alfabet dan satu nomor.",
  "createRoomFailed-1": "Gagal membuat kamar 1.",
  "createRoomFailed-2": "Gagal membuat kamar 2.",
  "createRoomFailed-3": "Gagal membuat kamar 3.",
  credit_amount_required: "Jumlah kredit dibutuhkan.",
  currency_required: "Mata uang dibutuhkan.",
  currencyNotSupported: "Mata uang tidak didukung",
  currPasswordRequired: "Kata sandi saat ini diperlukan",
  dataError: "Kesalahan data",
  debit_amount_required: "Jumlah debit dibutuhkan.",
  duplicate_credit_record: "Rekaman kredit duplikat.",
  duplicate_debit_record: "Odds Is Updating...",
  endDateRequired: "Tanggal akhir diperlukan!",
  EsportsDisabled: "E-Sports Game Dinonaktifkan",
  forbiddenAccess: "Akses Terlarang",
  FREEZE: "Akun telah dibekukan!",
  freeze: "Akun dibekukan! Silakan hubungi upline Anda untuk melanjutkan...",
  game_maintenance: "Game is under maintenance.",
  incompletedRequest: "Something goes wrong...",
  insufficient_balance: "Saldo tidak mencukupi",
  invalid_password: "Kata sandi salah",
  invalidBetAmount: "Jumlah taruhan tidak valid.",
  invalidBets: "Pasar ini tidak tersedia, silakan coba pasar lain.",
  invalidCurrency: "Mata uang tidak valid untuk bertaruh",
  invalidleague: "Liga tidak valid.",
  invalidMarketType: "Tipe pasar yang diberikan tidak valid.",
  invalidMatch: "Pertandingan tidak valid.",
  invalidMember: "Anggota tidak valid.",
  invalidOddsBall: "Odds Is Updating...",
  invalidOperator: "Operator tidak valid.",
  invalidPassword: "Password tidak valid",
  invalidRoom: "Ruangan tidak valid.",
  invalidRoomLimit: "Batas kamar tidak valid.",
  invalidRoomPassword: "Kode PIN tidak valid. Kode PIN harus berisi 6 angka.",
  invalidRoomRate: "Tarif kamar tidak valid.",
  invalidRoomType: "Tipe kamar tidak valid.",
  invalidRTSMatchOdds: "Odds RTS Match tidak valid.",
  invalidSession: "Session expired! Please login again to continue...",
  IPJoinedBefore: "IP sudah bergabung sebelumnya.",
  isAlpha: "{fname} hanya menerima alfabet",
  isAlphaNum: "{fname} hanya menerima alfanumerik",
  isEmail: "{fname} hanya menerima alamat email yang valid",
  isIpAddress: "{fname} hanya menerima alamat IPv4 yang valid",
  isMaxLength: "{fname} harus kurang dari atau sama dengan {fvalue}",
  isMaxValue: "{fname} harus kurang dari atau sama dengan {fvalue}.",
  isMinLength: "{fname} harus memiliki setidaknya {fvalue} karakter",
  isMinValue: "{fname} harus memiliki minimal {fvalue}.",
  isNumeric: "{fname} hanya menerima angka",
  isOutrightRequired: "Is outright is required!",
  // vuelidate
  isRequired: "Silakan masuk {fname}.",
  isSameAs: "{fname} harus sama dengan {fname2}.",
  isUrl: "{fname} hanya menerima URL",
  "joinFailed-1": "Gagal bergabung dengan kamar 1.",
  "joinFailed-2": "Gagal bergabung dengan kamar 2.",
  leagueIdRequired: "ID Liga diperlukan!",
  liveCasinoDisabled: "Live Casino Dinonaktifkan",
  liveMatchNotAllowed: "Pertandingan live tidak diizinkan.",
  //tournament
  login_id_not_exists: "Login tidak valid, silakan coba login kembali.",
  loginFailed: "Gagal masuk, silakan coba lagi nanti...",
  loginLimit: "Anda terlalu sering masuk, silakan coba lagi setelah 1 menit...",
  lotteryDisabled: "Lottery Dinonaktifkan",
  marketTypeChanged: "Bet Slip telah dihapus karena perubahan tipe pasar.<br />Silakan pilih kembali dari pasar.",
  marketTypeRequired: "Tipe Pasar diperlukan.",
  master_comm_rate_required: "Rate komisi master dibutuhkan.",
  master_id_required: "ID master dibutuhkan.",
  matchDateRequired: "Tanggal pertandingan dibutuhkan.",
  matchHide: "Pasar ini tidak tersedia, silakan coba pasar lain.",
  matchLowerMin: "Terjadi kesalahan match lower min.",
  matchNotActive: "Pasar ini tidak tersedia, silakan coba pasar lain.",
  matchNotAllowBet: "Pasar ini tidak tersedia, silakan coba pasar lain.",
  matchOverMax: "Terjadi kesalahan match over max.",
  matchRequired: "Pertandingan dibutuhkan.",
  maxMatch: "Maksimum {max} pertandingan yang dipilih.",
  maxParlayTicket: "Raih tiket maksimum per parlay!",
  maxRoomLimit: "Jumlah pemain harus sama atau kurang dari 30.",
  maxRoomRate: "Biaya masuk harus sama atau kurang dari 1000.",
  member_id_required: "ID member dibutuhkan.",
  member_wallet_not_exists: "Dompet member tidak ada.",
  memberExists: "Anggota sudah ada.",
  memberJoinedBefore: "Anda sudah bergabung sebelumnya, harap dicatat bahwa ruang bebas publik hanya bisa bergabung sekali.",
  minBetAmount: "Kesalahan jumlah taruhan minimum terjadi.",
  MiniGameDisabled: "Mini Game Dinonaktifkan",
  minMatch: "Minimum 3 pertandingan yang dipilih.",
  minRoomLimit: "Jumlah pemain harus sama atau lebih besar dari 3.",
  minRoomRate: "Biaya masuk harus sama atau lebih besar dari 10.",
  new_login_id_exists: "Nama panggilan tidak valid, cobalah untuk mengatur nama panggilan yang berbeda.",
  newPasswordRequired: "Diperlukan kata sandi baru!",
  nickNameRequired: "Nama panggilan wajib diisi!",
  noMatchSelected: "Silakan pilih setidaknya 1 pertandingan.",
  notSameAs: "{fname} dan {fname2} tidak bisa sama.",
  NoUserAccessRight: "Izin ditolak! Silakan hubungi upline untuk melanjutkan ...",
  oddsDisplayInvalid: "Odds Is Updating...",
  oddsIsUpdating: "Odds Is Updating...",
  OK: "Baik",
  pageNumberRequired: "Nomor halaman wajib diisi!",
  pageSizeRequired: "Diperlukan ukuran halaman!",
  passwordRequired: "Diperlukan kata sandi!",
  passwordsNotMatch: "Sandi tidak cocok!",
  permission_denied: "Izin ditolak.",
  pointsOverLimit: "Terjadi kesalahan poin melebihi batas.",
  rate_required: "Rate dibutuhkan.",
  rateLowerMin: "Terjadi kesalahan rate lower min.",
  rateOverMax: "Terjadi kesalahan rate over max.",
  requestFailed: "Koneksi Anda tidak stabil, harap periksa koneksi internet Anda dan coba lagi.",
  requestLimit: "You have request too frequent.",
  requestPending: "Permintaan tertunda...",
  result_exists: "Hasil sudah ada.",
  room_id_required: "ID ruangan dibutuhkan.",
  roomClosed: "Ruangan ditutup.",
  roomClosedNotAllowed: "Ruangan ditutup tidak diizinkan.",
  roomEnded: "Ruangan sudah berakhir.",
  roomEndedOrCancelled: "Ruangan berakhir atau dibatalkan.",
  roomExists: "Tidak diizinkan untuk membuat lebih dari 1 ruangan privat.",
  RoomExists: "Tidak diizinkan untuk membuat lebih dari 1 ruangan privat.",
  roomFull: "Kamar sudah penuh.",
  roomIdRequired: "ID kamar dibutuhkan.",
  roomIsPublicFree: "Kamar adalah bebas publik.",
  roomLimitLowerMin: "Terjadi kesalahan batas ruangan lower min.",
  roomLimitOverMax: "Terjadi kesalahan batas ruangan over max.",
  roomLimitRequired: "Batas kamar dibutuhkan.",
  roomNotExists: "Kamar tidak ada.",
  roomOverMax: "Terjadi kesalahan ruangan over max.",
  roomPasswordRequired: "Kode PIN dibutuhkan.",
  roomRateRequired: "Tarif kamar dibutuhkan.",
  roomTypeRequired: "Tipe kamar dibutuhkan.",
  s_senior_comm_rate_required: "Rate komisi super senior dibutuhkan.",
  s_senior_id_required: "ID super senior dibutuhkan.",
  secondary_account_exists: "Nama panggilan Anda sudah dibuat.",
  selectLeague: "Silakan pilih setidaknya 1 liga",
  selectOption: "Silakan pilih {fname}",
  senior_comm_rate_required: "Rate komisi senior dibutuhkan.",
  senior_id_required: "ID senior dibutuhkan.",
  session_expired: "Sesi berakhir! Silakan masuk lagi untuk melanjutkan...",
  session_not_exists: "Sesi berakhir! Silakan masuk lagi untuk melanjutkan...",
  sessionTokenRequired: "Token sesi dibutuhkan.",
  shareholder_comm_rate_required: "Tingkat komisi pemegang saham dibutuhkan.",
  shareholder_id_required: "ID pemegang saham dibutuhkan.",
  slotDisabled: "Slot Dinonaktifkan",
  sportsTypeRequired: "Jenis olahraga diperlukan!",
  startDateRequired: "Diperlukan tanggal mulai!",
  SUSPEND: "Akun Anda telah berubah menjadi hanya LIHAT.",
  suspend: "Akun ditangguhkan! Silakan hubungi upline Anda untuk melanjutkan...",
  systemError: "Kesalahan Sistem Internal",
  tournamentDisabled: "Turnamen dinonaktifkan, harap periksa kontak upline Anda.",
  tournamentLeagueExists: "Liga turnamen sudah ada.",
  tournamentMatchExists: "Pertandingan turnamen sudah ada.",
  transfer_id_required: "ID transfer dibutuhkan.",
  unableToGetBalanceAtTheMoment: "Kesalahan server internet",
  usernameRequired: "Nama pengguna harus diisi!",
  workingDateRequired: "Tanggal kerja diperlukan!",
  matchNotStarted: "Pertandingan belum dimulai.",
  cashOutUnavailable: "Keluar tidak tersedia.",
  errorCashoutAmount: "Keluar sedang diperbarui...",
  invalidParameter: "Parameter tidak valid.",
  startTimeRequired: "Waktu mulai diperlukan.",
  endTimeRequired: "Waktu selesai diperlukan.",
  oddsTypeIDRequired: "Tipe odds diperlukan.",
  commissionRequired: "Komisi diperlukan.",
  requestTimeRequired: "Waktu permintaan diperlukan.",
  statusRequired: "Status diperlukan.",
  invalidStartTime: "Waktu mulai tidak valid.",
  invalidEndTime: "Waktu selesai tidak valid.",
  invalidOddsTypeID: "Tipe odds tidak valid.",
  invalidCommission: "Komisi tidak valid.",
  invalidRequestTime: "Waktu permintaan tidak valid.",
  invalidStatus: "Status tidak valid.",
  invalidAlgoMatchInfo: "Pasar ini sudah ditutup, silakan coba pasar lain.",
  invalidAlgoSliderLeagueInfo: "Info liga tidak valid.",
  invalidAlgoSliderMinutesWeight: "Bobot menit tidak valid.",
  invalidAlgoSliderBetType: "Tipe taruhan tidak valid.",
  invalidRTSRunningScoreDetails: "Detail skor berjalan RTS tidak valid.",
  invalidProviderGoalTimeLine: "Info garis waktu tujuan tidak valid.",
  invalidSliderTimeRange: "Rentang waktu tidak valid.",
  invalidMOMatchOdds: "Odds match sedang diperbarui...",
  invalidProviderSlider: "Info TM tidak valid.",
  invalidCombineBetTypeAndOddsFormat: "Format kombinasi tipe taruhan dan odds tidak valid.",
  invalidMatchInformation: "Info pertandingan tidak valid.",
  marketClose: "Pasar ini tutup, silakan coba pasar lain.",
  error: "Kesalahan",
  freeRoomNeedBet: "Silakan pasang taruhan yang valid untuk mengakses ruangan gratis.",
};
